// extracted by mini-css-extract-plugin
module.exports = {"sbx0wy5":"sbx0wy5"};